// extracted by mini-css-extract-plugin
module.exports = {"fileUpload":"SingleFileUploadEdit_fileUpload__1le2A"};